export default "__VITE_ASSET__BjX6qtGw__"